import styled from 'styled-components';

export const CustomerDetailsSectionRoot = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
`;

export const CustomerDetailsDivider = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;

    &::before,
    &::after {
        content: '';
        flex: 1;
        height: 1px;
        background: ${({ theme }) => /* istanbul ignore next */ theme.tokens?.SemColorNeutral300 || '#d0d0d0'};
    }
`;

export const CustomerDetailsShareOptions = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;

    > * {
        flex: 1 1 20rem;
        min-width: 0;
    }
`;
